<template>
  <div class="box">
    <div class="head">
      <Header></Header>
    </div>
    <!-- 关于我们 -->
    <div class="div">
      <div class="across"></div>
      <div class="tabs">
        <div class="crumbs">
          <span>
            <!-- <router-link :to="{ path: '/' }"> -->
            <img src="../../assets/images/header/white.png" alt="logo" />
            首页
            <!-- </router-link> -->
          </span>
          <!-- &gt;
          <span @click="activeName = 'first'" style="cursor: pointer"
            >关于我们</span
          > -->
          &gt;
          <span>{{ text }}</span>
        </div>
        <el-tabs v-model="activeName">
          <el-tab-pane label="关于我们" name="first">
            <div class="AboutTheCompany">
              <div>
                <!-- <img src="../../assets/images/home/R-C.png" alt="" /> -->
                <video
                  width="80%"
                  controls
                  src="http://49.4.68.154/video/智慧环保成品.mp4"
                  preload="auto"
                  webkit-playsinline="true"
                  x5-video-player-type="h5"
                  title="企业宣传视频"
                ></video>
              </div>
              <div class="word">
                <div class="title">北京中泽宇华环境科技有限公司</div>
                <div class="content">
                  <!-- <p>
                    公司成立于2018年，总部位于北京，由来自生态环境部、中石化等多年从事环保技术研究和环保软件开发的专业人士组成。公司致力于环保技术服务和环保软件开发，先后与中国环境科学研究院、生态环境部评估中心、生态环境部规划院、腾讯、聚光科技、雪迪龙、仕净集团等知名科研院所和上市公司建立良好的合作关系。
                  </p>
                  <p>
                    公司在北京和武汉两地设立研发中心，产品主要涉及智慧环保信息化平台开发、“环保管家”、环保技术服务等领域，为多个工业园区及上千家工业企业提供环保数字化解决方案和环境咨询服务。
                  </p> -->
                  <div>
                    北京中泽宇华环境科技有限公司成立于2018年，在北京、武汉建立研发中心，由具有丰富的环保从业经验和软件开发人员创建，致力于开发灵活、实用、高效、智能化的环保信息化管理系统。
                  </div>
                  <div>
                    中泽宇华智慧环保系统历经多年升级迭代，先后在北京、江苏、湖南、湖北、山西等地成功应用，得到用户的一致好评。
                  </div>

                 
                  <div style="font-weight: 900;text-indent: 0;"> 系统功能特点：</div>
                  <div>
                    我们将传统的人工现场检查，升级为数字化远程监控，系统融合污染源在线监测、用水、用能、环评、排污许可、应急预案、固危废、视频监控等多项环保数据，技术团队根据多年的环保管理经验，建立多维出数据分析模型，打破数据孤岛、通过对各类数据联动分析，自动诊断异常数据并进行预警报警，将传统的数据超标报警，扩展至环保手续不全、自行监测污染因子漏检、治理设施去除效率不达标、未“先开后停”、危废产转异常、超期储存、超量存储、未按要求执行停限产、污染物排放总量超标等自动预警报警。
                  </div>
                  <div>
                    自动预警报警功能极大的提高环保管理的效率，通过预警报警——短信告知——现场检查或远程视频确认——事件处理——确认回复——销号，闭环管理流程，即使您是刚入行的环保从业者，也能进行精准的环保检查和服务，解决了人员少、专业知识匮乏的难点。divC端、移动端实时掌握环保管理现状、及时发现问题、及时整改，有效降低被问责、被处罚的风险。
                  </div>
                  <div>
                    系统可根据管理要求自动生产区域污染物因子库、各类污染物排放总量、企业排名、各企业管理现状、主要环境风险点等各类统计报表，有效减少查找资料和人员统计汇总时间，可节约50-70%。
                  </div>
                  <div>
                    非现场执法、强化环保数据应用已在全国开始试点，在线化、无纸化管理势在必行，中泽宇华首创多维数据联动分析，更精准、更全面的环保管理，必将进一步降低换环保管理成本，提高环保管理效率，让环境管理部门、排污企业放心管理。
                  </div>
                  <div>中泽宇华，引领环保智慧管理新时代。</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="关于产品" name="second">
            <div class="aboutOurProduct">
              <div>
                <img src="../../assets/images/aboutUs/SafeManager.png" alt="" />
              </div>
              <div class="word">
                <div class="text">
                  以“数字化、物联网、智能化”为理念进行平台建设，提升环保工作效率，提高对污染源
                  （排污企业）监管针对性，增强企业守法意识，通过环保局-企业环保平台联动，提升环保综合
                  管理水平！以“数字化、物联网、智能化”为理念进行平台建设，提升环保工作效率，提高对
                  污染源（排污企业）监管针对性，增强企业守法意识，通过环保局-企业环保平台联动，提升环
                  保综合管理水平！以“数字化、物联网、智能化”为理念进行平台建设。
                </div>
                <div class="interlinkage">
                  <el-button
                    type="primary"
                    round
                    style="position: absolute; bottom: 0; right: 0"
                    size="mini"
                    @click="to"
                    >点击跳转</el-button
                  >
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="资质荣誉" name="third">
            <div class="qualificationHonor">
              <div class="certificate">
                <div class="pic">
                  <img
                    src="../../assets/images/aboutUs/certificate.png"
                    alt=""
                  />
                </div>
                <div class="text">XX资质</div>
              </div>
              <div class="certificate">
                <div class="pic">
                  <img
                    src="../../assets/images/aboutUs/certificate.png"
                    alt=""
                  />
                </div>
                <div class="text">XX资质</div>
              </div>
              <div class="certificate">
                <div class="pic">
                  <img
                    src="../../assets/images/aboutUs/certificate.png"
                    alt=""
                  />
                </div>
                <div class="text">XX资质</div>
              </div>
              <div class="certificate">
                <div class="pic">
                  <img
                    src="../../assets/images/aboutUs/certificate.png"
                    alt=""
                  />
                </div>
                <div class="text">XX资质</div>
              </div>
              <div class="certificate">
                <div class="pic">
                  <img
                    src="../../assets/images/aboutUs/certificate.png"
                    alt=""
                  />
                </div>
                <div class="text">XX资质</div>
              </div>
              <div class="certificate">
                <div class="pic">
                  <img
                    src="../../assets/images/aboutUs/certificate.png"
                    alt=""
                  />
                </div>
                <div class="text">XX资质</div>
              </div>
              <div class="certificate">
                <div class="pic">
                  <img
                    src="../../assets/images/aboutUs/certificate.png"
                    alt=""
                  />
                </div>
                <div class="text">XX资质</div>
              </div>
              <div class="certificate">
                <div class="pic">
                  <img
                    src="../../assets/images/aboutUs/certificate.png"
                    alt=""
                  />
                </div>
                <div class="text">XX资质</div>
              </div>
            </div>
          </el-tab-pane> -->
        </el-tabs>
      </div>
    </div>

    <div class="foot">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "@/views/header/Header.vue";
import Footer from "@/views/footer/Footer.vue";
export default {
  components: { Header, Footer },
  data() {
    return {
      activeName: "first",
      text: "关于我们",
    };
  },

  created() {
    this.$store.state.menu = 3;
  },

  mounted() {
    this.query();
  },

  methods: {
    query() {
      // console.log(888, this.$route.query.id);
      if (this.$route.query.id != undefined) {
        this.activeName = this.$route.query.id;
      }
    },
    to() {
      window.open("http://49.4.68.154:9530/", "_blank");
    },
  },
  watch: {
    activeName(news) {
      // console.log("ddd", news);
      switch (news) {
        case "first":
          // console.log("first");
          this.text = "关于公司";
          break;
        case "second":
          // console.log("second");
          this.text = "关于产品";
          break;
        case "third":
          // console.log("third");
          this.text = "资质荣誉";
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  .head {
    position: fixed;
    width: 100%;
    height: 100px;
    background-color: #fff;
    z-index: 5;
    color: #333;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  }
  .div {
    width: 100%;
    // min-width: 1550px;
    padding-top: 100px;
    .across {
      width: 100%;
      height: 50px;
      background-color: #0064a1;
    }
    .tabs {
      position: relative;
      padding: 0 50px;
      max-width: 1200px;
      min-width: 900px;
      margin: auto;
      margin-top: -45px;
      .AboutTheCompany {
        margin: 70px auto;
        width: 85%;
        > div:nth-child(1) {
          width: 100%;
          text-align: center;
          // height: 40vh;
          // img {
          //   width: 100%;
          //   height: 100%;
          // }
        }
        .word {
          // width: 100%;
          width: 816px;
          margin: 0 auto;
          height: 100%;
          padding-top: 50px;
          .title {
            font-size: 35px;
            color: #008cd7;
            font-weight: bold;
            height: 20%;
          }
          .content {
            font-size: 16px;
            text-indent: 2em;
            color: #666666;
            line-height: 2;
            height: 80%;
            overflow: auto;
            &::-webkit-scrollbar {
              display: none; /*隐藏滚动条*/
            }
            text-align: justify;
            div:nth-child(1) {
              padding-top: 20px;
            }
          }
        }
      }
      .aboutOurProduct {
        margin: 70px 0;
        display: flex;
        height: 25vh;
        > div:nth-child(1) {
          width: 40%;
          height: 25vh;
        }
        img {
          width: 100%;
          height: 100%;
        }
        > div:nth-child(1):hover {
          width: 40%;
          height: 100%;
          overflow: hidden;
          img {
            width: 110%;
            height: 110%;
            margin-left: -5%;
            margin-top: -5%;
            margin-bottom: -10%;
            transition: 0.5s;
            -moz-transition: 0.5s; /* Firefox 4 */
            -webkit-transition: 0.5s; /* Safari 和 Chrome */
            -o-transition: 0.5s; /* Opera */
          }
        }
        .word {
          width: 60%;
          position: relative;
          color: #666666;
          font-size: 16px;
          text-indent: 2em;
          line-height: 1.5;
          padding-left: 50px;
          .text {
            height: 80%;
            overflow: auto;
            &::-webkit-scrollbar {
              display: none; /*隐藏滚动条*/
            }
          }
          .interlinkage {
            height: 20%;
          }
        }
      }
      .qualificationHonor {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 70px;
        margin-bottom: 50px;
        width: 100%;
        height: 100%;
        .certificate {
          width: 22%;
          // height: 45%;
          .pic {
            width: 100%;
            // height: 16vh;
            img {
              width: 100%;
              // height: 100%;
            }
          }
          // .pic:hover {
          //   width: 100%;
          //   height: 16vh;
          //   overflow: hidden;
          //   img {
          //     width: 110%;
          //     height: 110%;
          //     margin-left: -5%;
          //     margin-top: -3%;
          //     transition: 0.5s;
          //     -moz-transition: 0.5s; /* Firefox 4 */
          //     -webkit-transition: 0.5s; /* Safari 和 Chrome */
          //     -o-transition: 0.5s; /* Opera */
          //   }
          // }
          .text {
            height: 14%;
            line-height: 1.5;
            color: #333;
            text-align: center;
          }
        }
      }
    }
  }
  .crumbs {
    position: absolute;
    right: 50px;
    line-height: 40px;
    z-index: 2;
    color: #fff;
    font-size: 16px;
  }
  .router-link-active {
    text-decoration: none;
    color: #fff;
  }
  // tabs标题的字号
  /deep/ .el-tabs__item {
    font-size: 16px;
  }
}
</style>
